export const SEARCH_INPUT_CLEAR = 'SEARCH_INPUT_CLEAR';
export const SEARCH_INPUT_SET_VALUE = 'SEARCH_INPUT_SET_VALUE';

const initialState = { value: '' };

export const clearSearchInput = () => ({
  type: SEARCH_INPUT_CLEAR,
});

export const setSearchInputValue = searchValue => ({
  type: SEARCH_INPUT_SET_VALUE,
  payload: searchValue,
});

export const searchInputReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_INPUT_CLEAR: {
      return { value: '' };
    }
    case SEARCH_INPUT_SET_VALUE: {
      return { value: payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/search-input.reducer.js